export default "__VITE_ASSET__BUb09GUz__"